export default function Privacy() {
  return (
    <div style={{ fontFamily:"'IBM Plex Mono','Courier New',monospace", background:"#06080f", minHeight:"100vh", color:"#e8f0f8" }}>
      <div style={{ maxWidth:800, margin:"0 auto", padding:"40px 24px 80px" }}>

        <div style={{ marginBottom:40, borderBottom:"1px solid rgba(180,200,220,0.1)", paddingBottom:24 }}>
          <div style={{ fontFamily:"monospace", fontSize:10, color:"#60a5fa", letterSpacing:"0.2em", textTransform:"uppercase", marginBottom:12 }}>Corporate Disclosure Scanner</div>
          <h1 style={{ fontSize:24, fontWeight:700, color:"#f1f5f9", marginBottom:8 }}>Privacy Policy</h1>
          <div style={{ fontFamily:"monospace", fontSize:10, color:"#64748b" }}>Last updated: April 2025 · Controller: Avv. Dr. Gian Marco Solas · gmsolas@sustainab-law.eu</div>
        </div>

        {[
          {
            title: "1. Who we are",
            body: `The Corporate Disclosure Scanner (corporate-scanner.com) is operated by Avv. Dr. Gian Marco Solas, lawyer, Sustainab-Law (gmsolas@sustainab-law.eu). For any privacy-related enquiry, contact us at the above address.`
          },
          {
            title: "2. What data we collect",
            body: `We collect minimal data:

· Scan data: when you run a scan, the results (company name, document type, jurisdiction, scores, anomaly categories) may be stored anonymously in our database for research purposes. No personal data about the user is collected during scanning.

· Booking data: if you book a consultation via Calendly, Calendly collects your name, email address, and meeting details. This is governed by Calendly's own privacy policy.

· Technical data: standard server logs (IP address, browser type, pages visited) may be collected by our hosting provider (Vercel) for security and performance purposes.

We do not use tracking cookies, advertising pixels, or third-party analytics.`
          },
          {
            title: "3. Legal basis for processing (GDPR)",
            body: `· Scan data: legitimate interest (Art.6(1)(f) GDPR) — building an empirical dataset to validate a physics-reviewed legal framework. Data is anonymised and aggregated.

· Booking data: performance of a contract (Art.6(1)(b) GDPR) — necessary to provide the legal consultation service you requested.

· Technical logs: legitimate interest (Art.6(1)(f) GDPR) — security and performance of the service.`
          },
          {
            title: "4. How we use the data",
            body: `· Scan results are used solely for academic research purposes — to build an empirical dataset validating the legal-physics framework published in the Journal of Law, Market & Innovation (JLMI 1/25).

· We do not sell, share, or commercialise personal data.

· We do not use scan results to identify or profile individual users.

· Aggregated, anonymised statistics may be published in academic papers.`
          },
          {
            title: "5. Data retention",
            body: `· Anonymised scan data: retained indefinitely for research purposes.

· Booking and consultation data: retained for 5 years in accordance with legal professional obligations.

· Server logs: retained for 30 days.`
          },
          {
            title: "6. Your rights (GDPR)",
            body: `If you are in the EU/EEA, you have the following rights:

· Right of access — request a copy of data we hold about you
· Right to erasure — request deletion of your data
· Right to rectification — request correction of inaccurate data
· Right to portability — receive your data in a portable format
· Right to object — object to processing based on legitimate interest
· Right to lodge a complaint — with your national Data Protection Authority

To exercise any of these rights, contact: gmsolas@sustainab-law.eu`
          },
          {
            title: "7. Data transfers",
            body: `Our service uses the following third-party processors:

· Vercel Inc. (USA) — hosting and deployment. Vercel is certified under the EU-US Data Privacy Framework.

· Supabase Inc. (USA) — database storage. Data is stored in EU regions where possible. Supabase complies with GDPR as a data processor.

· Anthropic PBC (USA) — AI analysis. Documents submitted for scanning are processed by Anthropic's API. Anthropic operates a zero data retention policy for API requests. No document content is retained by Anthropic.

· Calendly LLC (USA) — meeting scheduling. Governed by Calendly's own privacy policy and GDPR compliance documentation.`
          },
          {
            title: "8. Security",
            body: `We implement appropriate technical and organisational measures to protect data against unauthorised access, including encrypted transmission (HTTPS), server-side API key storage, and access controls on our database.`
          },
          {
            title: "9. Changes to this policy",
            body: `We may update this policy from time to time. Material changes will be noted with an updated date at the top of this page.`
          },
          {
            title: "10. Contact",
            body: `For any privacy-related question or to exercise your rights:\n\nAvv. Dr. Gian Marco Solas\ngmsolas@sustainab-law.eu\ncorporate-scanner.com`
          },
        ].map((s, i) => (
          <div key={i} style={{ marginBottom:32 }}>
            <h2 style={{ fontSize:13, fontWeight:700, color:"#60a5fa", fontFamily:"monospace", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}>{s.title}</h2>
            <div style={{ fontSize:12, color:"#94a3b8", lineHeight:1.9, whiteSpace:"pre-line" }}>{s.body}</div>
          </div>
        ))}

        <div style={{ borderTop:"1px solid rgba(180,200,220,0.08)", paddingTop:24, fontFamily:"monospace", fontSize:9, color:"#3b4a5a", lineHeight:1.8 }}>
          © 2025 Avv. Dr. Gian Marco Solas · Corporate Disclosure Scanner · Framework published in JLMI 1/25 · Not investment advice
        </div>
      </div>
    </div>
  );
}
